module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.recharge.dialog),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "dialog", $$v)
      },
      expression: "recharge.dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Dodaj novac")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n               " + _vm._s(_vm.recharge.user.name) + "\n             ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Iznos"
    },
    model: {
      value: (_vm.recharge.transaction.value),
      callback: function($$v) {
        _vm.$set(_vm.recharge.transaction, "value", $$v)
      },
      expression: "recharge.transaction.value"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Komentar"
    },
    model: {
      value: (_vm.recharge.transaction.comment),
      callback: function($$v) {
        _vm.$set(_vm.recharge.transaction, "comment", $$v)
      },
      expression: "recharge.transaction.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.recharge.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.postRecharge()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "hide-actions": "",
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.created)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.last_login)))]), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.name,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "name", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.name) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.name),
            callback: function($$v) {
              _vm.$set(props.item, "name", $$v)
            },
            expression: "props.item.name"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.roles,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "roles", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.roles) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.roles),
            callback: function($$v) {
              _vm.$set(props.item, "roles", $$v)
            },
            expression: "props.item.roles"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.phone,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "phone", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.phone) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.phone),
            callback: function($$v) {
              _vm.$set(props.item, "phone", $$v)
            },
            expression: "props.item.phone"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.address,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "address", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.address) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.address),
            callback: function($$v) {
              _vm.$set(props.item, "address", $$v)
            },
            expression: "props.item.address"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.balance))]), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.credit,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "credit", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.credit) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.credit),
            callback: function($$v) {
              _vm.$set(props.item, "credit", $$v)
            },
            expression: "props.item.credit"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.exclusive_courier_id,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "exclusive_courier_id", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.exclusive_courier_id) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.exclusive_courier_id),
            callback: function($$v) {
              _vm.$set(props.item, "exclusive_courier_id", $$v)
            },
            expression: "props.item.exclusive_courier_id"
          }
        })], 1)], 1), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.proxy_id,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.$set(props.item, "proxy_id", $event)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.proxy_id) + "\n          "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "single-line": ""
          },
          slot: "input",
          model: {
            value: (props.item.proxy_id),
            callback: function($$v) {
              _vm.$set(props.item, "proxy_id", $$v)
            },
            expression: "props.item.proxy_id"
          }
        })], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "justify-end layout px-0"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(props.item.android_registration) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("android")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Ima instaliranu aplikaciju")])], 1), _vm._v(" "), (!props.item.approved) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.approveUser(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.saveUser(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("save")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showRechargeDialog(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("euro_symbol")])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_vm._v("\n      učitavanje...\n    ")])], 2)], 1)
},staticRenderFns: []}